<template>
  <div class="w-full">
    <div class="flex items-center justify-between">
      <BookLabel background="bg-project" class="py-4 font-semibold" :book="item" />

      <div
        class="rotate-icon opacity-0 group-hover:opacity-100 anim-opacity"
        :class="{'opacity-100': activeIndex}"
      >
        <i class="icon-arrow-up text-19 font-bold text-dark-600" />
      </div>
    </div>
    <!-- eslint-disable vue/no-v-html -->
    <div class="highlight text-grey-250 ml-40 text-12" v-html="subTitle" />
  </div>
</template>

<script>
import { defineComponent, computed } from 'vue'
import BookLabel from '@/components/books/BookLabel'

export default defineComponent({
  components: { BookLabel },

  props: {
    item: Object,
    activeIndex: Boolean,
    query: String
  },

  setup (props) {
    const subTitle = computed(() => {
      return props.item.highlight?.subTitle || props.item.subTitle
    })

    return {
      // ref
      // data
      // computed
      subTitle
      // function
    }
  }
})
</script>
